import { postRequest } from '../../httpClient';
import type { IRecomputeClipTimingData } from './recompute-clip-timing-data';
import type { IRecomputeClipTimingResponse } from './recompute-clip-timing-response';
import { recomputeClipTimingResponseSchema } from './recompute-clip-timing-response';

export async function recomputeClipTimingApi(clipId: number): Promise<IRecomputeClipTimingData> {
  const result = await postRequest<IRecomputeClipTimingResponse>({
    path: `/sys/clips/${clipId}/recompute-timing`,
    schema: recomputeClipTimingResponseSchema,
  });
  // biome-ignore lint/style/noNonNullAssertion: safe - validated response always has data on success
  return result.data.data!;
}
